import { Ellipsis, Pencil, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function FeatureFlagsTableActions({
  flag,
  canManage = false,
  onEdit = () => {},
  onDelete = () => {},
}) {
  if (!canManage) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label="Flag actions"
        className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
      >
        <Ellipsis />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="tw:w-auto">
        <DropdownMenuItem onClick={() => onEdit(flag)}>
          <Pencil />
          Edit
        </DropdownMenuItem>
        {/* System flags cannot be deleted, so the item is omitted entirely. */}
        {!flag.is_system && (
          <DropdownMenuItem
            variant="destructive"
            onClick={() => onDelete(flag)}
          >
            <Trash2 />
            Delete
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
